import { apiClientes } from "../config/api";
import { RetornaAceiteTermoResponse } from "../interfaces/entities/RetornaAceiteTermoResponse";
import { TermoResponsabilidade } from "../interfaces/entities/TermoResponsabilidade";
import { Response } from "../interfaces/services/Response";
import { getTokenClientes } from "../Store/storages/AuthenticationStorage";

export const retornaTermoResponsabilidadeManualCronicos = async (): Promise<Response | null> => {
    try {
        const response = await apiClientes.get('TermoResponsabilidade/RetornaTermoResponsabilidadeManualCronicos', {
            headers: { Authorization: `Bearer ${await getTokenClientes()}` }
        });

        return response;
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const retornaTermoResponsabilidadeSaudeEmocional = async (): Promise<TermoResponsabilidade | null> => {
    try {
        const response = await apiClientes.get('TermoResponsabilidade/RetornaTermoResponsabilidadeSaudeEmocional', {
            headers: { Authorization: `Bearer ${await getTokenClientes()}` }
        });

        return response.data;
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const retornaAceiteSaudeEmocional = async (): Promise<RetornaAceiteTermoResponse | null> => {
    try {
        const response = await apiClientes.get('TermoResponsabilidade/RetornaAceiteSaudeEmocional', {
            headers: { Authorization: `Bearer ${await getTokenClientes()}` }
        });

        return response.data;
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const aceitaTermoResponsabilidade = async (idTermo: string, indAceite: string): Promise<Response | null> => {
    try {
        const response = await apiClientes.get('TermoResponsabilidade/AceitaTermoResponsabilidade', {
            params: { idTermo, indAceite },
            headers: { Authorization: `Bearer ${await getTokenClientes()}` }
        });
        return response;
    } catch (error) {
        console.log({ error });
        return null;
    }
};